import DashboardSettings from './entities/dashboard-settings';

export default {
  modules: {
    DashboardSettings,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/index.js